const LOGO_URL = "https://media.lostdrkc.in/wp-content/uploads/2026/10/Lostdrkc-logo-Black-2-e1792640099301.png";

/**
 * LostDRKC logo. Original artwork is BLACK, so we place it on a
 * yellow rounded container by default (dark theme). Use `variant="plain"`
 * on light surfaces where the raw asset can breathe.
 */
export default function Logo({ size = 40, variant = "chip", className = "", showWordmark = true, wordmarkClass = "" }) {
  if (variant === "plain") {
    return (
      <img
        src={LOGO_URL}
        alt="LostDRKC"
        style={{ height: size, width: "auto", objectFit: "contain" }}
        className={className}
        data-testid="ldc-logo"
      />
    );
  }
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="ldc-logo">
      <div
        className="flex items-center justify-center rounded-lg shadow-[0_0_0_1px_rgba(251,206,24,0.4)]"
        style={{
          background: "linear-gradient(135deg, #fbce18 0%, #f5b800 100%)",
          padding: 6,
          height: size,
          minWidth: size,
        }}
      >
        <img src={LOGO_URL} alt="LostDRKC" style={{ height: size - 12, width: "auto", objectFit: "contain" }} />
      </div>
      {showWordmark && (
        <div className={wordmarkClass}>
          <div className="font-display font-semibold tracking-tight leading-none text-[15px]">LostDRKC</div>
          <div className="text-[9px] tracking-[0.26em] uppercase text-white/45">Payments</div>
        </div>
      )}
    </div>
  );
}

export { LOGO_URL };
